module.exports = __webpack_public_path__ + "static/media/carpenter.5af9079c.jpg";